import { render, staticRenderFns } from "./UpdateAudio.vue?vue&type=template&id=2facf6a4&"
import script from "./UpdateAudio.vue?vue&type=script&lang=js&"
export * from "./UpdateAudio.vue?vue&type=script&lang=js&"
import style0 from "./UpdateAudio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports